module.exports = __webpack_public_path__ + "img/send.6434862f.png";